// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host([auto-fit]) {
  height: 100%;
}

:host([auto-fit]) ::slotted(.ids-tabs-content) {
  height: 100%;
}

.orientation-vertical {
  display: flex;
}

.auto-fit {
  height: 100%;
}

:host ids-header {
  position: sticky;
  top: 0;
  z-index: 30;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-tabs/ids-tabs-context.scss"],"names":[],"mappings":"AACA;EACE,YAAA;AAAF;;AAGA;EACE,YAAA;AAAF;;AAGA;EACE,aAAA;AAAF;;AAGA;EACE,YAAA;AAAF;;AAIE;EACE,gBAAA;EACA,MAAA;EACA,WAAA;AADJ","sourcesContent":["\n:host([auto-fit]) {\n  height: 100%;\n}\n\n:host([auto-fit]) ::slotted(.ids-tabs-content) {\n  height: 100%;\n}\n\n.orientation-vertical {\n  display: flex;\n}\n\n.auto-fit {\n  height: 100%;\n}\n\n:host {\n  ids-header {\n    position: sticky;\n    top: 0;\n    z-index: 30;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
